import {CoworkBarePanel} from '../admin/CoworkFormPanel';
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Categoria, deleteCategoria } from '../../services/blogCategorias';

interface DeleteBlogCategoriaProps {
  isOpen: boolean;
  categoria: Categoria | null;
  onClose: () => void;
  onSuccess: () => void;
}

const DeleteBlogCategoria: React.FC<DeleteBlogCategoriaProps> = ({ isOpen, categoria, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!categoria) return;
    setLoading(true);
    setError(null);

    try {
      await deleteCategoria(categoria.id);
      onSuccess();
      onClose();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al eliminar la categoría');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={onClose}></div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        <CoworkBarePanel data-luma-dialog="true" className="inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium leading-6 text-gray-900">Eliminar Categoría</h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="mb-4">
              <p className="text-sm text-gray-700">
                ¿Estás seguro de eliminar la categoría <strong>{categoria?.nombre}</strong>?
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Esta acción no se puede deshacer. Las publicaciones asociadas pasarán a tener categoría null.
              </p>
              {error && <p className="text-sm text-red-600 mt-4">{error}</p>}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleDelete}
                disabled={loading}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
              >
                {loading ? 'Eliminando...' : 'Eliminar'}
              </button>
            </div>
          </div>
        </CoworkBarePanel>
      </div>
    </div>
  );
};

export default DeleteBlogCategoria;
